import { parse } from "wellknown";
import Performance from "@/utils/map/Map_Performance";
import Element from "@/utils/map/Map_Element";
import Imagery from "@/utils/map/Map_Imagery";
import Model3d from "@/utils/map/Map_Model3d";
import Flight from "@/utils/map/Map_Flight";
import DynamicMission from "@/utils/map/Map_DynamicMission";

import { toast } from "vue3-toastify";

import CesiumNavigation from "cesium-navigation-es6";
import { getServerConfig } from "./serverConfig";

var OLDPOSITION = null;

class Map {
  app;
  // ---
  viewer;
  id_cesiumContainer;
  performance;
  element;
  imagery;
  model3d;
  flight;
  dynamicmission;
  polylines;
  max_distance_show;
  // ---
  drawTracker;
  // ---
  trakersList;
  autoPitch;
  //
  timerDrawHelp;

  constructor() { }

  async setup_map(app) {
    self.app = app;
    self.id_cesiumContainer = "cesiumContainer";
    self.max_distance_show = 5000;

    const serverConfig = await getServerConfig();
    const isCesiumIonConnected = serverConfig.isCesiumIonConnected;
    const token = serverConfig.cesiumToken;

    // Configure le chemin des assets Cesium locaux - utile pour le mode offline et NaturalEarthII
    Cesium.buildModuleUrl.setBaseUrl('/Cesium/');

    let config = {
      animation: false,
      sceneModePicker: false,
      homeButton: false,
      timeline: false,
      skyBox: false,
      fullscreenButton: false,
      projectionPicker: false,
      baseLayerPicker: false,
      baseLayer: Cesium.ImageryLayer.fromProviderAsync(
        Cesium.TileMapServiceImageryProvider.fromUrl(
          Cesium.buildModuleUrl("Assets/Textures/NaturalEarthII"),
        ),
      ),
      geocoder: false,
      navigationHelpButton: false,
      infoBox: false,
      /* --- */
      mapProjection: new Cesium.WebMercatorProjection(),
      // config.mapMode2D = Cesium.MapMode2D.ROTATE;

      //selectionIndicator: false,
    };

    /* --- ONLINE / Cesium Ion--- */
    if (isCesiumIonConnected && self.app.map_data.online) {
      Cesium.Ion.defaultAccessToken = token;
      // config.baseLayer = Cesium.ImageryLayer.fromProviderAsync(
      //   Cesium.IonImageryProvider.fromAssetId(2)
      // );
      config.terrain = Cesium.Terrain.fromWorldTerrain();
    }
    /* --- OFFLINE --- */
    else {
      config.imageryProvider = false;
    }

    /** ------- */

    if (self.app.map_data._mode == 2) {
      config.sceneMode = Cesium.SceneMode.SCENE2D;
    }

    /** ------- */

    // if (!self.app.isPopup) {
    // }
    this.viewer = new Cesium.Viewer(self.id_cesiumContainer, config);
    app.$root.mapJsLoaded = true;
    this.flyToFrance();

    this.autoPitch = {
      active: false,
      sens: false,
      transform: undefined,
      heading: 0,
      pitch: 0,
      range: 0,
    };

    const options = {};
    options.enableCompass = true;
    options.enableZoomControls = false;
    options.enableDistanceLegend = false;
    options.enableCompassOuterRing = true;
    new CesiumNavigation(this.viewer, options);

    /** ------- */
    this.viewer.scene.debugShowFramesPerSecond = false;
    this.viewer.scene.screenSpaceCameraController._zoomFactor = 3;
    this.viewer.scene.screenSpaceCameraController.inertiaZoom = 0.8;
    this.viewer.screenSpaceEventHandler.removeInputAction(
      Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK
    );
    this.viewer.scene.globe.depthTestAgainstTerrain = true;

    this.viewer.scene.fog.density = 2.0e-4;
    this.viewer.scene.fog.minimumBrightness = 0.1;
    this.viewer.scene.fog.enabled = $root.user.getSettingsFog();
    this.viewer.scene.globe.enableLighting = true;

    //this.viewer.scene.camera.percentageChanged = 0.01;


    /** ------- */
    this.bindCenterMapPoint();
    self.drawTracker = new GlobeTracker(this.viewer);
    self.app.drawTracker = self.drawTracker;
    this.bindGloveEvent();
    /** ------- */

    this.bindTrackerEvent();

    this.performance = new Performance(this.viewer);
    this.element = new Element(this.viewer, self.app);
    this.imagery = new Imagery(this.viewer);
    this.model3d = new Model3d(this.viewer);
    this.dynamicmission = new DynamicMission(this.viewer, self.app);
    this.flight = new Flight(this.viewer, this.model3d, this.performance, id_cesiumContainer);
    this.viewer.scene.postUpdate.addEventListener(this.posUpdate.bind(this));
    this.viewer.canvas.addEventListener("webglcontextlost", this.loseContext);

    let handler = new Cesium.ScreenSpaceEventHandler(this.viewer.canvas);
    handler.setInputAction((movement) => {
      let pickedObject = this.viewer.scene.pick(movement.position);

      if (Cesium.defined(pickedObject)) {
        let id = pickedObject.id.customId.split("__mapElements__");

        if (!$root.user.can([4, 5], 'CARTE.MAPELEMENTS.edit')) {
          toast.error(
            "Vous n'avez pas les droits pour éditer les éléments de la carte.",
            $root.toastConfig
          );
          return;
        }

        if (id[1] !== undefined) {
          id = parseInt(id[1]);

          let mapelement = this.element.dynamicmapelements.getById(id);
          // console.log(id, mapElement, mapelement);
          if (
            mapelement != undefined &&
            mapelement !== null &&
            mapelement.dynamic !== null
          ) {
            mapelement.dynamic.infos.key = Date.now();
            this.setCustomMapElement(mapelement.dynamic);
            this.toggle_popup_mapelement(true);
          }
        }
      }

    }, Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
  }

  loseContext() {
    console.log("context lost");
    alert("Le context WEBGL a été perdu. La page va se recharger.");
    location.reload();
  }



  posUpdate() {
    if (this.autoPitch.active === true) {
      const delta = 0.01;
      this.autoPitch.pitch =
        this.autoPitch.sens === true
          ? this.autoPitch.pitch - delta
          : this.autoPitch.pitch + delta;

      if (this.autoPitch.sens === true && this.autoPitch.pitch < -Cesium.Math.PI_OVER_TWO + 0.2) {
        this.autoPitch.active = false;
        this.viewer.camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
      }
      else if (this.autoPitch.sens === false && this.autoPitch.pitch > -Cesium.Math.PI_OVER_FOUR + 0.2) {
        this.autoPitch.active = false;
        this.viewer.camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
        //// console.log("reset down");
      } else {
        //// console.log(this.autoPitch.pitch);
        this.viewer.camera.lookAtTransform(
          this.autoPitch.transform,
          new Cesium.HeadingPitchRange(
            this.autoPitch.heading,
            this.autoPitch.pitch,
            this.autoPitch.range
          )
        );
      }
    }
    else {
      if (this.viewer.camera.pitch > -Cesium.Math.PI_OVER_TWO + 0.4) {
        this.autoPitch.sens = false;
      }
      else {
        this.autoPitch.sens = true;
      }
      $root.global.id2D = this.autoPitch.sens;
    }
  }

  getViewer() {
    return this.viewer;
  }

  getApp() {
    return self.app;
  }

  bindCenterMapPoint() {
    var handler = new Cesium.ScreenSpaceEventHandler(this.viewer.canvas);
    handler.setInputAction((click) => {
      let ray = this.viewer.camera.getPickRay(click.position);
      let earthPosition = this.viewer.scene.globe.pick(ray, this.viewer.scene);

      if (Cesium.defined(earthPosition)) {
        this.viewer.map_center = this.viewer.entities.add({
          position: earthPosition,
          billboard: {
            //image: "https://" + ENV.HOST + "/assets/images/map_center.svg",
            image: "/assets/images/map_center.svg",
            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
            // disableDepthTestDistance: Number.POSITIVE_INFINITY,
            // clampToGround: true,
            scale: 1,
          },
        });
      }
    }, Cesium.ScreenSpaceEventType.MIDDLE_DOWN);

    handler.setInputAction((event) => {
      this.viewer.entities.remove(this.viewer.map_center);
    }, Cesium.ScreenSpaceEventType.MIDDLE_UP);
  }

  resetDraw() {
    app.map_draw = {};
  }

  addDrawOption(object) {
    app.map_draw = object;
  }

  flyToFrance() {
    this.viewer.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(
        2.424722222222222,
        46.7630556,
        1000000
      ),
    });
  }


  buttonMapElementsCreator(bool) {
    app.showMapElementsCreator = bool;
  }

  pin_n_focus(coord, name, option) {
    this.add_pin(coord, name, option);
    this.focus(coord);
  }

  add_pin(coord, name, option) {
    let pinBuilder = new Cesium.PinBuilder();

    if (typeof option == "undefined") {
      option = {
        image: pinBuilder.fromColor(Cesium.Color.ROYALBLUE, 48).toDataURL(),
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        markerSize: 80,
      };
    }

    if (!Object.hasOwnProperty.call(coord, "hgt")) {
      coord.hgt = 0;
    }

    option.heightReference = Cesium.HeightReference.CLAMP_TO_GROUND;
    option.disableDepthTestDistance = Number.POSITIVE_INFINITY;

    let size = 250;

    return this.viewer.entities.add({
      name: name,
      position: Cesium.Cartesian3.fromDegrees(coord.lng, coord.lat, coord.hgt),
      billboard: option,
      markerSize: 24,
    });
  }

  add_pin_Site(site) {
    if (this.viewer?.entities == undefined) {
      setTimeout(() => {
        this.add_pin_Site(site);
      }, 2000);
      return;
    }

    let size = 75;

    let color = site.sit_active
      ? ["#2D5C88", "#62b3ff"]
      : ["#eb2626", "#FF4141"];

    let svg =
      `<svg width="` +
      size +
      `" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104.366 158.064">
      <path fill="` +
      color[1] +
      `" d="M19.269,5H85.04c7.929,0,14.326,8.321,14.326,18.641V70.715c0,10.321-6.378,18.642-48.276,78.478C11.353,89.4,5,81,5,70.678V23.648C5,13.334,11.384,5.006,19.325,5.006Z" />
      <path fill="none" stroke="` +
      color[0] +
      `" stroke-width="10" d="M19.269,5H85.04c7.929,0,14.326,8.321,14.326,18.641V70.715c0,10.321-6.378,18.642-48.276,78.478C11.353,89.4,5,81,5,70.678V23.648C5,13.334,11.384,5.006,19.325,5.006Z" />
      <path d="M53.325,79.3H21.255a4,4,0,0,1-3.828-4.019,4.109,4.109,0,0,1,1.148-2.985,3.8,3.8,0,0,1,2.419-1.172V23.28A7.335,7.335,0,0,1,22.549,18.6a5.876,5.876,0,0,1,4.486-2.171h4.957L28.643,23.3v.092l3.376-6.962H51.278a5.885,5.885,0,0,1,4.215,1.854,7.091,7.091,0,0,1,1.822,4.987V24.62q.009,2.776.006,5.566V30.6H66.25l2.738-.009c.468,0,.935,0,1.4.009,3.31.042,5.947,2.93,6,6.575,0,.16,0,.343,0,.525V71.121a4.034,4.034,0,0,1,3.572,4,4.115,4.115,0,0,1-1.148,3,3.763,3.763,0,0,1-2.68,1.182h-3.38l-.341.006L72.36,79.3H53.711l-.3.011ZM68.73,71.112l0-32.344c-.1,0-11.4,0-11.4,0l.022,32.341Zm-19.042,0c0-.792-.032-37.452-.032-37.452q-.009-2.8-.006-5.594V24.607l-1.25,0H28.643l0,46.5Z"/>
      <path fill="#fff"  d="M51.278,18.426a3.891,3.891,0,0,1,2.781,1.247,5.13,5.13,0,0,1,1.256,3.593V24.62q.009,2.782.006,5.565,0,1.206,0,2.414H66.249c.911,0,1.825-.01,2.739-.01q.686,0,1.372.01a4.391,4.391,0,0,1,4.031,4.6c.006.238,0,.482,0,.719V73.112h1.744a2.111,2.111,0,0,1,0,4.185h-.092q-.355,0-.713,0c-.476,0-.951,0-1.427,0h-1.3c-.016,0-.03.006-.046.007h-.006c-.025,0-.05-.007-.075-.007H53.567c-.015,0-.03.006-.045.007h-.006c-.026,0-.05-.007-.075-.007H21.255a2.111,2.111,0,0,1,0-4.185h.092c.212,0,.425,0,.637,0,.337,0,.673,0,1.01,0V23.281A5.318,5.318,0,0,1,24.1,19.855a3.9,3.9,0,0,1,2.958-1.429Zm.163,4.181-.029-.031s.009.015.025.031h0m-23.825,0h-.034c-.185,0-.374,0-.562.007-.053.014-.107.032-.159.051-.032.022-.066.041-.1.06l-.019.022c-.013.015-.024.028-.037.045s-.014.033-.022.048c-.014.054-.025.11-.037.166,0,.015,0,.032,0,.047V73.112H51.693V73.07c-.007-1.444-.007-2.881-.007-4.325,0-2-.006-4-.006-6.006,0-2.364-.006-4.736-.006-7.1,0-2.532-.006-5.092-.006-7.6s-.006-5.015-.006-7.526c0-2.281-.006-4.569-.006-6.85q-.009-2.8-.006-5.593V24.32c0-.444.011-.9-.01-1.343-.01-.049-.024-.1-.037-.146-.016-.032-.029-.063-.045-.095l0-.007a.466.466,0,0,0-.038-.043l-.024-.015c-.059-.021-.12-.043-.18-.058l-.021,0c-.321-.006-.642-.007-.963-.007-.643,0-1.285.007-1.928.007H27.616m27.736,50.5H70.724c0-.872.008-1.744.008-2.616V38.13c0-.316,0-.639-.008-.96-.012-.057-.027-.115-.042-.171-.016-.03-.028-.061-.043-.091l0-.005a.5.5,0,0,0-.041-.047c-.015-.011-.033-.02-.049-.031-.057-.021-.116-.044-.176-.06-.2-.015-.4-.02-.6-.02-.444,0-.89.025-1.32.025H55.326q0,.855,0,1.709c0,3.244.005,6.438.005,9.724s.006,6.563.006,9.842c0,2.9.007,5.782.007,8.677,0,2.044.006,4.088.006,6.131v.259M70.508,36.764l-.014-.015.009.014h.005m.02.021,0-.006h-.005l0,0,.006,0M51.305,14.426H27.01A7.866,7.866,0,0,0,21,17.327a9.318,9.318,0,0,0-2.009,5.954V69.6a5.921,5.921,0,0,0-1.86,1.306,6.117,6.117,0,0,0-1.705,4.448A5.983,5.983,0,0,0,21.255,81.3H53.272c.082.005.162.007.244.007h.1l.107,0,.038,0H72.311c.082.005.163.007.244.007h.1l.107,0,.039,0h1.8l.727,0q.376,0,.753,0h.052A5.77,5.77,0,0,0,80.256,79.5a6.116,6.116,0,0,0,1.706-4.448,6.207,6.207,0,0,0-3.571-5.463V37.718c0-.208,0-.417,0-.622a8.333,8.333,0,0,0-7.98-8.5c-.467-.008-.945-.011-1.422-.011s-.929,0-1.392,0-.9.006-1.347.006H59.321q0-2-.006-3.993V23.266a9.065,9.065,0,0,0-2.38-6.373,7.94,7.94,0,0,0-5.6-2.467ZM30.646,26.611h17v1.455q0,2.8.006,5.607l0,3.416,0,3.42,0,3.768,0,3.758,0,3.791,0,3.812,0,3.556,0,3.545,0,3.009,0,3v.367H30.646ZM59.329,40.77h7.4V69.112H59.348l0-2.39,0-4.343,0-4.334,0-4.92,0-4.922,0-4.9Z" />
      <path d="M74.87,86.779a9.344,9.344,0,0,1-9.355-8.96L65.459,75.8h3.753a9.761,9.761,0,0,0-4.728-2.2,7.942,7.942,0,0,0-4.052,1.851l-.059.051s-.283.2-.424.3h3.419v1.5a9.268,9.268,0,0,1-9.251,9.264h-.007a9.257,9.257,0,0,1-.541-18.5l.166-.005,1.877-.941,0,4.994q.381-.5.739-1l.045-.064.052-.059a7.641,7.641,0,0,0,1.8-3.789,6.713,6.713,0,0,0-1.633-3.582l-.064-.074-.055-.082c-.176-.26-.488-.68-.885-1.189v3.651h-1.5a9.256,9.256,0,1,1,0-18.511h1.5v.13a9.265,9.265,0,0,1,7.74,8.585l.063,2.045H59.35c.521.387,1.053.776,1.24.9a7.114,7.114,0,0,0,8.141-.142c.27-.222.6-.488.939-.754H65.5v-1.5a9.253,9.253,0,1,1,9.8,9.236l-2.044.062V62.6l-.35.449-.047.05a7.7,7.7,0,0,0-2.018,4.286A7.689,7.689,0,0,0,73,71.52l.1.1s.127.187.152.221V69.2l.567-1.132,1.05-.018a9.366,9.366,0,0,1,.133,18.732ZM54.108,73.658a3.688,3.688,0,0,0-3.7,3.651A3.674,3.674,0,0,0,54.063,81a3.691,3.691,0,0,0,3.687-3.422l0-.112a5.414,5.414,0,0,0-.94,1.144l-1,1.615-.379-.379a2.928,2.928,0,0,1-3.965-1.75,2.926,2.926,0,0,1,2.04-3.755,1.545,1.545,0,0,0,.709-.536s.108-.131.125-.15Zm17,3.676a3.645,3.645,0,1,0,3.918-3.665l-.279-.01q.186.194.38.38a2.557,2.557,0,0,0,.53.412,2.918,2.918,0,1,1-3.825,3.636,4.052,4.052,0,0,0-.515-.564c-.053-.053-.125-.117-.209-.189M54.12,53.026a3.644,3.644,0,0,0-.276,7.278l.175.007a6.1,6.1,0,0,0-1.24-.979,2.918,2.918,0,0,1-1.056-3.97,2.92,2.92,0,0,1,5.321.582,7.3,7.3,0,0,0,.717.9v-.175a3.646,3.646,0,0,0-3.641-3.647m20.631.848a2.927,2.927,0,0,1,1.091,5.577,2.593,2.593,0,0,0-.831.794l-.047.066a3.686,3.686,0,0,0,3.5-3.645,3.674,3.674,0,0,0-3.651-3.7,3.689,3.689,0,0,0-3.687,3.424l-.026.667.214-.165a2.62,2.62,0,0,0,.407-.581,2.921,2.921,0,0,1,2.885-2.444Z" fill-rule="evenodd"/>
      <path fill="#fff" d="M54.117,48.914v.008h0a7.754,7.754,0,0,1,7.741,7.3l.013.456H59.261a5.143,5.143,0,0,0-5.14-5.148h0A5.144,5.144,0,0,0,53.732,61.8l.385.015v2.61a7.756,7.756,0,1,1,0-15.511m20.642.008a7.752,7.752,0,0,1,.455,15.491l-.455.013V61.815h.033a5.173,5.173,0,0,0,.031-10.346H74.79a5.173,5.173,0,0,0-5.16,4.821l-.016.386H67a7.754,7.754,0,0,1,7.754-7.754h0m-.153,6.448.071,0a1.427,1.427,0,0,1,.532,2.719,4.116,4.116,0,0,0-1.444,1.319s-.9,1.265-1.994,2.661a9.143,9.143,0,0,0-2.441,5.352,9.254,9.254,0,0,0,2.616,5.16,16.336,16.336,0,0,0,2.144,2.536,3.921,3.921,0,0,0,1,.728l.016,0a1.418,1.418,0,1,1-1.9,1.59,5.588,5.588,0,0,0-.883-1.022c-.29-.3-.987-.807-1.783-1.436a11.328,11.328,0,0,0-6.044-2.9,9.482,9.482,0,0,0-5.051,2.231c-.415.29-1.213.892-2.256,1.67a6.943,6.943,0,0,0-1.659,1.846l-.014-.013A1.425,1.425,0,1,1,53.89,75.8a3.076,3.076,0,0,0,1.534-1.089,33.723,33.723,0,0,0,2.157-2.728,9.174,9.174,0,0,0,2.186-4.752,8.25,8.25,0,0,0-2.021-4.6c-.362-.537-1.137-1.534-1.919-2.5a7.718,7.718,0,0,0-2.276-2.084,1.42,1.42,0,1,1,2.1-1.49,8.843,8.843,0,0,0,1.926,2.17s1.744,1.309,2.187,1.6a8.618,8.618,0,0,0,9.845-.18c1.008-.827,2.708-2.131,2.708-2.131a4.15,4.15,0,0,0,.864-1.287,1.426,1.426,0,0,1,1.423-1.357m.269,14.176a7.866,7.866,0,0,1,.111,15.732H74.87a7.868,7.868,0,0,1-7.857-7.525L67,77.3h2.611a5.144,5.144,0,0,0,5.138,5.151h.006a5.145,5.145,0,0,0,.385-10.275l-.385-.015V69.55l0,0h.116m-20.758,0v2.611h-.033A5.173,5.173,0,0,0,54.053,82.5h.033a5.173,5.173,0,0,0,5.16-4.819l.015-.385h2.608a7.757,7.757,0,0,1-7.752,7.762h-.006a7.757,7.757,0,0,1-.453-15.5l.455-.013,0,0m0-23.633a10.756,10.756,0,0,0-3.045,21.072A10.758,10.758,0,1,0,64.418,80.393,10.843,10.843,0,0,0,74.87,88.279h.159a10.865,10.865,0,0,0,2.834-21.31,10.753,10.753,0,0,0-3.1-21.046h0a10.769,10.769,0,0,0-10.321,7.711,10.794,10.794,0,0,0-7.319-7.286v-.425ZM72.4,67.5l.076,0-.053.093c-.008-.03-.016-.061-.023-.091" />
    </svg>`;

    let name = "";
    if (site?.name !== undefined) {
      name = site.name;
    } else if (site?.sit_name !== undefined) {
      name = site.sit_name;
    }

    return this.viewer.entities.add({
      name: name,
      position: Cesium.Cartesian3.fromDegrees(site.sit_lng, site.sit_lat),
      ellipse: {
        semiMinorAxis: 1,
        semiMajorAxis: 1,
        material: new Cesium.ImageMaterialProperty({
          image: `data:image/svg+xml;base64,` + btoa(svg),
        }),
        heightReference: Cesium.HeightReference.NONE,
      },
    });
  }

  add_geometry(geo, option, focus) {
    if (this?.viewer?.dataSources == undefined) {
      setTimeout(() => {
        this.add_geometry(geo, option, focus);
      }, 2000);
      return;
    }

    if (typeof option == "undefined") {
      option = {
        markerSize: 24,
        material: new Cesium.PolylineDashMaterialProperty({
          color: Cesium.Color.WHITE,
        }),
        markerSymbol: "t",
        name: "",
      };
    }
    if (typeof focus == "undefined") {
      focus = true;
    }

    geo = parse(geo);

    Cesium.GeoJsonDataSource.load(geo, option).then((data) => {
      this.viewer.dataSources.add(data);
      data.name = option.name;
      if (focus) {
        this.viewer.flyTo(data);
      }
    });
  }

  add_mission(geo, nomSite) {
    return;
    self.polylines = this.viewer.scene.primitives.add(
      new Cesium.PolylineCollection()
    );

    let sphereSize = 1;
    let lngGlobal = 0;
    let latGlobal = 0;

    geo = parse(geo);

    let colection = new Cesium.EntityCollection();

    geo.coordinates.forEach((coord, i) => {
      lngGlobal += coord[0];
      latGlobal += coord[1];

      let h = coord[2] + "m";
      let point = "";
      let pointLabel = "";

      let color = Cesium.Color.fromCssColorString("#2D5C88");
      let colorText = Cesium.Color.fromCssColorString("#fff");

      if (i == 0) {
        point = "de Départ";
        pointLabel = "D";
        color = Cesium.Color.fromBytes(81, 255, 0);
        colorText = Cesium.Color.fromBytes(0, 0, 0);
      } else if (i + 1 == geo.coordinates.length) {
        point = "d' Arrivée";
        pointLabel = "A";
        color = Cesium.Color.fromBytes(255, 25, 0);
        colorText = Cesium.Color.fromBytes(255, 255, 255);
      } else {
        point = (i + 1).toString();
        pointLabel = (i + 1).toString();
      }

      let description = `
        <ul>
          <li>Longitude : ${coord[0]}</li>
          <li>Latitude : ${coord[1]}</li>
          <li>Hauteur : ${coord[2]}</li>
        </ul>`;

      let entity = this.viewer.entities.add({
        name: "Point " + point,
        position: Cesium.Cartesian3.fromDegrees(coord[0], coord[1], coord[2]),
        description: description,
        zIndex: 50,
        ellipsoid: {
          radii: new Cesium.Cartesian3(sphereSize, sphereSize, sphereSize),
          material: color.withAlpha(0.85),
        },

        ellipse: {
          semiMinorAxis: 0.5,
          semiMajorAxis: 0.5,

          maximumRadius: 50,
          minimumRadius: 0.5,
          material: color,
        },

        polyline: {
          positions: Cesium.Cartesian3.fromDegreesArrayHeights([
            coord[0],
            coord[1],
            coord[2],
            coord[0],
            coord[1],
            0,
          ]),
          width: 1,
          material: new Cesium.PolylineDashMaterialProperty({
            color: Cesium.Color.WHITE.withAlpha(0.8),
          }),
        },

        distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
          0.0,
          self.max_distance_show
        ),
      });

      colection.add(entity);

      let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 80 80">
        <path d="M40,0,80,80H0Z" transform="translate(80 80) rotate(180)" fill="` + color.toCssColorString() + `"/>
        <text transform="translate(40 40)" fill="` + colorText.toCssColorString() + `" font-size="35" font-family="ArialMT, Arial"><tspan x="-9.733" y="0">` + pointLabel + `</tspan></text>
      </svg>`;

      entity = this.viewer.entities.add({
        name: "Point " + point,
        position: Cesium.Cartesian3.fromDegrees(coord[0], coord[1], coord[2]),
        description: description,
        zIndex: 1,
        billboard: {
          image: `data:image/svg+xml;base64,` + btoa(svg),
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BASELINE,

          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
            0.0,
            self.max_distance_show
          ),
          pixelOffsetScaleByDistance: new Cesium.NearFarScalar(
            200,
            2,
            self.max_distance_show,
            0.1
          ),
        },
      });

      colection.add(entity);

      if (i < geo.coordinates.length - 1) {
        var polyline = self.polylines.add({
          positions: Cesium.Cartesian3.fromDegreesArrayHeights([
            coord[0],
            coord[1],
            coord[2],
            geo.coordinates[i + 1][0],
            geo.coordinates[i + 1][1],
            geo.coordinates[i + 1][2],
          ]),
          width: 20,
          zIndex: 99,
          material: Cesium.Material.fromType("PolylineArrow", {
            color: Cesium.Color.fromBytes(255, 255, 255),
            glowPower: 0.2,
            taperPower: 0.2,
          }),
          scaleByDistance: new Cesium.NearFarScalar(
            200,
            2,
            self.max_distance_show,
            0
          ),
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
            0.0,
            self.max_distance_show
          ),
        });

        colection.add(polyline);
      }
    });

    // this.viewer.entities.add({
    //   name: nomSite,
    //   position: Cesium.Cartesian3.fromDegrees(lngGlobal, latGlobal, 1000),
    //   label: {
    //     text: nomSite,
    //     font: "18pt sans-serif",

    //     horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
    //     verticalOrigin: Cesium.VerticalOrigin.BOTTOM,

    //     backgroundColor: Cesium.Color.fromBytes(255, 255, 255),
    //     backgroundPadding: new Cesium.Cartesian2(8, 4),
    //     fillColor: Cesium.Color.fromBytes(0, 0, 0),
    //     showBackground: true,
    //     // scaleByDistance: new Cesium.NearFarScalar(200, 2, self.max_distance_show, 0.1),
    //     distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
    //       self.max_distance_show,
    //       Number.POSITIVE_INFINITY
    //     ),
    //     disableDepthTestDistance: Number.POSITIVE_INFINITY,
    //   },
    //   billboard: {
    //     heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
    //     disableDepthTestDistance: Number.POSITIVE_INFINITY,
    //   },
    // });

    // this.viewer.flyTo (this.viewer.entities, {
    //   offset: new Cesium.HeadingPitchRange(
    //     Cesium.Math.toRadians(0),
    //     Cesium.Math.toRadians(-90),
    //     500
    //   ),
    //   duration: 1,
    // })

    lngGlobal /= geo.coordinates.length;
    latGlobal /= geo.coordinates.length;

    this.viewer.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(
        lngGlobal,
        latGlobal,
        geo.coordinates[0][2] + 500
      ),
      orientation: {
        pitch: Cesium.Math.toRadians(-90),
      },
      duration: 2,
    });

    //return collection;
    //igo 31/05/2024
    return colection;
  }

  remove_mission(collection) {
    this.viewer.entities.remove(collection);
  }

  async newAddCustomArea(geo, id, name) {
    let subzones = 0;

    geo = geo.replace(" ZM ", "");
    geo = parse(geo);

    var collection = new Cesium.EntityCollection("zone_" + id);

    geo.coordinates.forEach((customArea) => {
      // FLYZONE
      let points = customArea[0];
      let color = Cesium.Color.LIME;

      this._CustomAreaLine(collection, points, color, name);

      // NOFLIGHTZONE
      if (customArea.length > 1) {
        for (let i = 1; i < customArea.length; i++) {
          subzones++;
          points = customArea[i];
          color = Cesium.Color.RED;

          this._CustomAreaLine(collection, points, color, name);
        }
      }
    });

    return {
      FlightZone: geo.coordinates.length,
      NoFlightZone: subzones,
      collection: collection
    };
  }

  _CustomAreaLine(collection, points, color, name) {
    points.forEach((point, i) => {
      let p1 = point;
      let p2 = i == 0 ? points[points.length - 1] : points[i - 1];

      var entity = this.viewer?.entities?.add({
        name: name,
        polyline: {
          positions: Cesium.Cartesian3.fromDegreesArrayHeights([
            p1[0],
            p1[1],
            0,
            p2[0],
            p2[1],
            0,
          ]),
          width: 4,
          material: color,
          clampToGround: true,
          scaleByDistance: new Cesium.NearFarScalar(
            200,
            1,
            self.max_distance_show,
            0
          ),
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
            0.0,
            self.max_distance_show
          ),
        },
      });

      collection.add(entity);

      entity = this.viewer.entities.add({
        name: name,
        polyline: {
          positions: Cesium.Cartesian3.fromDegreesArrayHeights([
            p1[0],
            p1[1],
            0,
            p2[0],
            p2[1],
            0,
          ]),
          width: 12,
          material: new Cesium.PolylineDashMaterialProperty({
            color: color,
            dashPattern: parseInt("10", 2),
          }),
          clampToGround: true,
          scaleByDistance: new Cesium.NearFarScalar(
            200,
            1,
            self.max_distance_show,
            0
          ),
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
            0.0,
            self.max_distance_show
          ),
        },
      });

      collection.add(entity);
    });
  }

  focus(coord) {
    // Vérifier que le viewer est initialisé
    if (!this.viewer || !this.viewer.camera) {
      console.warn("Cesium viewer is not initialized");
      return;
    }

    let lng = coord.lng;
    let lat = coord.lat;
    let hgt = Object.hasOwnProperty.call(coord, "hgt") ? coord.hgt : 5500;

    this.viewer.camera.cancelFlight();

    let positions = [this.viewer.camera.positionCartographic.clone()];
    if (this.viewer.terrainProvider != undefined) {
      Cesium.sampleTerrain(this.viewer.terrainProvider, 9, positions).then(
        function (samples) {
          if (
            samples != undefined &&
            samples.length > 0 &&
            samples[0].height != null &&
            samples[0].height != undefined
          ) {
            this.viewer.camera.flyTo({
              destination: Cesium.Cartesian3.fromDegrees(
                lng,
                lat,
                samples[0].height + hgt
              ),
              duration: 1.5,
            });
          } else {
            this.viewer.camera.flyTo({
              destination: Cesium.Cartesian3.fromDegrees(lng, lat, hgt),
              duration: 1.5,
            });
          }
        }.bind(this)
      );
    } else {
      this.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(lng, lat, hgt),
        duration: 1.5,
      });
    }
  }

  async getGroundHeight(cartographic) {
    let positions = [cartographic];
    if (this.viewer.terrainProvider != undefined) {
      return await Cesium.sampleTerrain(this.viewer.terrainProvider, 9, positions).then(
        async function (samples) {
          if (
            samples != undefined &&
            samples.length > 0 &&
            samples[0].height != null &&
            samples[0].height != undefined
          ) {
            return samples[0].height;
          }
          else {
            return undefined;
          }
        });
    }
    return undefined;
  }

  async pickRayCast(cartographic) {

    if (this.viewer.terrainProvider === undefined) {
      return 0;
    }
    const cartesianUp = Cesium.Cartesian3.fromDegrees(
      cartographic.longitude,
      cartographic.latitude,
      10000
    );
    const cartesianDown = Cesium.Cartesian3.fromDegrees(
      cartographic.longitude,
      cartographic.latitude,
      0
    );
    const direction = Cesium.Cartesian3.normalize(
      Cesium.Cartesian3.subtract(
        cartesianDown,
        cartesianUp,
        new Cesium.Cartesian3()
      ),
      new Cesium.Cartesian3()
    );
    const ray = new Cesium.Ray(cartesianUp, direction);

    const hiddenEntities = this.preparePick(false);

    const intersec = this.viewer.scene.pickFromRay(
      ray,
      hiddenEntities
    );

    this.preparePick(true);

    if (intersec !== undefined && Cesium.defined(intersec.position)) {
      const cartographicRadians = Cesium.Cartographic.fromCartesian(
        intersec.position
      );
      if (cartographicRadians.height >= 0) {
        return cartographicRadians.height;
      }
    }

    const cartographicRadians = new Cesium.Cartographic(Cesium.Math.toRadians(cartographic.longitude), Cesium.Math.toRadians(cartographic.latitude), 0);

    const height = await this.getGroundHeight(cartographicRadians);
    if (height != undefined) {
      //console.log("Ground height" + height);
      return height;
    }

    return 0;
  }

  preparePick(isShow) {
    let datasources = [];

    this.viewer.dataSources._dataSources.forEach((dataSource) => {
      if (dataSource.name != "MapModels3d") {
        dataSource.entities.values.forEach((entity) => {
          datasources.push(entity);
        });
        dataSource._primitives._primitives.forEach((primitive) => {
          primitive.show = isShow;
        });
      }
    });

    return datasources;
  }

  pickTerrain(position) {
    const ray = this.viewer.scene.camera.getPickRay(position);
    const cartesian = this.viewer.scene.globe.pick(ray, this.viewer.scene);
    return cartesian;
  }


  clear() {
    this.dynamicmission?.clear();
    /*
    // console.log("clear");
    //this.viewer.dataSources.removeAll();
    this.viewer.entities.removeAll();
    if (typeof self.polylines == 'object'){
      self.polylines.removeAll();
    }*/
  }

  clearDraw() {
    /*
    this.viewer.entities._entities._array.forEach((entity) => {
      if (entity.layerId == ENV.DRAW_LAYER_ID) {
        this.viewer.entities.remove(entity);
      }
    });*/
  }

  clear_canvas_height() {
    let cesiumContainer = document.querySelector(
      "#" + self.id_cesiumContainer + " canvas"
    );
    cesiumContainer.style = "height:calc(100vh - 4rem)";
  }

  ZoomIfIsReload() {
    if (this?.viewer?.camera == undefined) {
      setTimeout(() => {
        this.ZoomIfIsReload();
      }, 2000);
      return;
    }

    let height = Cesium.Cartographic.fromCartesian(this.viewer.camera._position)?.height;
    if (self.app.$root.global.site != undefined && height > 100000) {
      this.focus({
        lat: self.app.$root.global.site.sit_lat,
        lng: self.app.$root.global.site.sit_lng,
        hgt: 1500
      })
    }
  }

  zoomIn(amount) {
    /*
    this.viewer.camera.zoomIn(
      this.ZoomFactor(amount)
    );*/
    let positions = [this.viewer.camera.positionCartographic.clone()];
    Cesium.sampleTerrain(this.viewer.terrainProvider, 9, positions).then(
      function (samples) {
        if (samples != undefined && samples.length > 0) {
          let zoom = 0;
          let height_sol = Math.abs(
            this.viewer.camera.positionCartographic.height - samples[0].height
          );
          if (height_sol > 10) {
            zoom = height_sol / amount;
          }
          this.viewer.scene.camera.zoomIn(zoom);
        } else {
          let zoom = 0;
          let height_sol = Math.abs(
            this.viewer.camera.positionCartographic.height
          );
          if (height_sol > 10) {
            zoom = height_sol / amount;
          }
          this.viewer.scene.camera.zoomIn(zoom);
        }
      }.bind(this)
    );
  }

  zoomOut(amount) {
    /*this.viewer.camera.zoomOut(
      this.ZoomFactor(amount)
    );*/
    let positions = [this.viewer.camera.positionCartographic.clone()];
    Cesium.sampleTerrain(this.viewer.terrainProvider, 9, positions).then(
      function (samples) {
        if (samples != undefined && samples.length > 0) {
          let height_sol = Math.abs(
            this.viewer.camera.positionCartographic.height - samples[0].height
          );
          let zoom = 100;
          if (height_sol > 10) {
            zoom = height_sol / amount;
          }
          this.viewer.scene.camera.zoomOut(zoom);
        } else {
          let height_sol = Math.abs(
            this.viewer.camera.positionCartographic.height
          );
          let zoom = 100;
          if (height_sol > 10) {
            zoom = height_sol / amount;
          }
          this.viewer.scene.camera.zoomOut(zoom);
        }
      }.bind(this)
    );
  }

  ZoomFactor(amount) {
    let height = this.viewer.camera.positionCartographic.height;

    if (height < 2000) {
      return amount;
    } else if (height < 5000) {
      return amount * 10;
    } else if (height < 50000) {
      return amount * 100;
    } else {
      return amount * 1000;
    }
  }

  get_max_distance_show() {
    return this.max_distance_show;
  }

  focus_entities() {
    this.viewer.flyTo(this.viewer.entities, {
      offset: new Cesium.HeadingPitchRange(
        Cesium.Math.toRadians(0),
        Cesium.Math.toRadians(-90),
        500
      ),
      duration: 1,
    });
  }

  get_shapeDic(id) {
    return id == undefined ? app.shapeDic : app.shapeDic[id];
  }

  /** --- */
  /** --- */
  /** --- */
  /** --- */
  /** --- */
  /** --- */

  bindGloveEvent() {
    var handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
    handler.setInputAction((movement) => {
      var pick = this.viewer.scene.pick(movement.position);
      if (!pick) {
        return;
      }

      var obj = pick.id;

      if (app.flag == 0) {
        return;
      }

      var objId = obj?.objId ? obj.objId : obj._id;

      //est un drapeau d'édition ou de suppression, 1 correspond à l'édition, 2 à la suppression.
      if (app.flag == 1) {
        switch (obj.shapeType) {
          case "CustomArea":
            app.flag = 0;
            this.editCustomArea(objId);
          case "Polygon":
            app.flag = 0;
            this.editPolygon(objId, app.map_draw["Polygon"]);
            break;
          case "Point":
            app.flag = 0;
            this.editPoint(objId, app.map_draw["Point"]);
            break;
          case "LineString":
            app.flag = 0;
            this.editPolyline(objId);
            break;
          case "Rectangle":
            app.flag = 0;
            this.editRectangle(objId);
            break;
          case "Circle":
            app.flag = 0;
            this.editCircle(objId);
            break;
          case "BufferLine":
            app.flag = 0;
            this.editBufferLine(objId);
            break;
          case "StraightArrow":
            app.flag = 0;
            this.editStraightArrow(objId);
            break;
          case "AttackArrow":
            app.flag = 0;
            this.editAttackArrow(objId);
            break;
          case "PincerArrow":
            app.flag = 0;
            this.editPincerArrow(objId);
            break;
          default:
            break;
        }
      } else if (app.flag == 2) {
        this.clearEntityById(objId);
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
  }

  showPolygon(objId, positions) {
    var material = Cesium.Color.fromCssColorString("#ff0").withAlpha(0.5);
    var outlineMaterial = new Cesium.PolylineDashMaterialProperty({
      dashLength: 16,
      color: Cesium.Color.fromCssColorString("#00f").withAlpha(0.7),
    });

    var outlinePositions = [].concat(positions);
    outlinePositions.push(positions[0]);

    var bData = {
      layerId: ENV.DRAW_LAYER_ID,
      objId: objId,
      shapeType: "Polygon",
      polyline: {
        positions: outlinePositions,
        clampToGround: true,
        width: 2,
        material: outlineMaterial,
      },
      polygon: new Cesium.PolygonGraphics({
        hierarchy: positions,
        asynchronous: false,
        material: material,
      }),
    };
    return this.viewer.entities.add(bData);
  }

  showCustomArea(objId, positions) {
    var outlinePositions = [].concat(positions);
    outlinePositions.push(positions[0]);

    let data = JSON.parse(objId);
    // console.log(data);

    let color = Cesium.Color.fromCssColorString(data.color);
    let material = color.withAlpha(0);
    let outlineMaterial = color;

    // console.log("showCustomArea", positions);

    var bData = {
      layerId: ENV.DRAW_LAYER_ID,
      objId: objId,
      id: objId,
      name: data.name,
      shapeType: "CustomArea",
      polyline: {
        positions: outlinePositions,
        clampToGround: true,
        width: 2,
        material: outlineMaterial,
        zIndex: data.zIndex,
      },
      polygon: new Cesium.PolygonGraphics({
        hierarchy: positions,
        asynchronous: false,
        material: material,
        zIndex: data.zIndex,
      }),
    };

    app.shapeDic[objId] = positions;
    return this.viewer.entities.add(bData);
  }

  showPolyline(objId, positions) {
    var material = new Cesium.PolylineGlowMaterialProperty({
      glowPower: 0.25,
      color: Cesium.Color.fromCssColorString("#00f").withAlpha(0.9),
    });
    var bData = {
      layerId: ENV.DRAW_LAYER_ID,
      objId: objId,
      shapeType: "LineString",
      polyline: {
        positions: positions,
        clampToGround: true,
        width: 8,
        material: material,
      },
    };
    var entity = this.viewer.entities.add(bData);
  }
  showRectangle(objId, positions) {
    var material = Cesium.Color.fromCssColorString("#ff0").withAlpha(0.5);
    var outlineMaterial = new Cesium.PolylineDashMaterialProperty({
      dashLength: 16,
      color: Cesium.Color.fromCssColorString("#00f").withAlpha(0.7),
    });
    var rect = Cesium.Rectangle.fromCartesianArray(positions);
    var arr = [
      rect.west,
      rect.north,
      rect.east,
      rect.north,
      rect.east,
      rect.south,
      rect.west,
      rect.south,
      rect.west,
      rect.north,
    ];
    var outlinePositions = Cesium.Cartesian3.fromRadiansArray(arr);
    var bData = {
      layerId: ENV.DRAW_LAYER_ID,
      objId: objId,
      shapeType: "Rectangle",
      polyline: {
        positions: outlinePositions,
        clampToGround: true,
        width: 2,
        material: outlineMaterial,
      },
      rectangle: {
        coordinates: rect,
        material: material,
      },
    };
    var entity = this.viewer.entities.add(bData);
  }
  showCircle(objId, positions) {
    var material = Cesium.Color.fromCssColorString("#ff0").withAlpha(0.5);
    var outlineMaterial = new Cesium.PolylineDashMaterialProperty({
      dashLength: 16,
      color: Cesium.Color.fromCssColorString("#f00").withAlpha(0.7),
    });
    var radiusMaterial = new Cesium.PolylineDashMaterialProperty({
      dashLength: 16,
      color: Cesium.Color.fromCssColorString("#00f").withAlpha(0.7),
    });
    var pnts = app.drawTracker.circleDrawer._computeCirclePolygon(positions);
    var dis = app.drawTracker.circleDrawer._computeCircleRadius3D(positions);
    dis = (dis / 1000).toFixed(3);
    var text = dis + "km";
    var bData = {
      layerId: ENV.DRAW_LAYER_ID,
      objId: objId,
      shapeType: "Circle",
      position: positions[0],
      label: {
        text: text,
        font: "16px Helvetica",
        fillColor: Cesium.Color.SKYBLUE,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 1,
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        eyeOffset: new Cesium.ConstantProperty(
          new Cesium.Cartesian3(0, 0, -9000)
        ),
        pixelOffset: new Cesium.Cartesian2(16, 16),
      },
      billboard: {
        image: "assets/images/circle_center.png",
        eyeOffset: new Cesium.ConstantProperty(new Cesium.Cartesian3(0, 0, 0)),
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      },
      polyline: {
        positions: positions,
        clampToGround: true,
        width: 2,
        material: radiusMaterial,
      },
      polygon: new Cesium.PolygonGraphics({
        hierarchy: pnts,
        asynchronous: false,
        material: material,
      }),
    };
    var entity = this.viewer.entities.add(bData);

    var outlineBdata = {
      layerId: ENV.DRAW_LAYER_ID,
      objId: objId,
      shapeType: "Circle",
      polyline: {
        positions: pnts,
        clampToGround: true,
        width: 2,
        material: outlineMaterial,
      },
    };
    var outlineEntity = this.viewer.entities.add(outlineBdata);
  }

  showPoint(objId, position) {
    let size = 50;
    let color = "#fff";
    let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" viewBox="0 0 249.487 249.487">
        <path d="M158.921,4.576,36.533,36.543,24.545,82.44,0,176.414l60.112-15.7,79.769-20.835,4.567-17.487,27.4-104.905L176.414,0ZM114.039,114.048,44.1,132.315,62.37,62.379l69.935-18.266Z" transform="translate(0 124.744) rotate(-45)" fill="${color}"/>
      </svg>`;

    // let heightReference = Cesium.HeightReference.CLAMP_TO_GROUND;

    return this.viewer.entities.add({
      layerId: ENV.DRAW_LAYER_ID,
      objId: objId,
      shapeType: "Point",
      position: position,
      billboard: {
        image: `data:image/svg+xml;base64,${btoa(svg)}`,
        eyeOffset: new Cesium.ConstantProperty(new Cesium.Cartesian3(0, 0, 0)),
        // heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1, 1.5e7, 0.2),
        pixelOffsetScaleByDistance: new Cesium.NearFarScalar(
          1.0e3,
          0.8,
          1.5e6,
          0.0
        ),
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
        // heightReference: heightReference,
        clampToGround: true,
        scale: 1,
      },
    });
  }

  showBufferLine(objId, positions, radius) {
    var buffer = app.drawTracker.bufferLineDrawer.computeBufferLine(
      positions,
      radius
    );
    var material = Cesium.Color.fromCssColorString("#ff0").withAlpha(0.5);
    var lineMaterial = new Cesium.PolylineDashMaterialProperty({
      dashLength: 16,
      color: Cesium.Color.fromCssColorString("#00f").withAlpha(0.7),
    });
    var bData = {
      layerId: ENV.DRAW_LAYER_ID,
      objId: objId,
      shapeType: "BufferLine",
      polygon: new Cesium.PolygonGraphics({
        hierarchy: buffer,
        asynchronous: false,
        material: material,
      }),
      polyline: {
        positions: positions,
        clampToGround: true,
        width: 2,
        material: lineMaterial,
      },
    };
    var entity = this.viewer.entities.add(bData);
  }

  showStraightArrow(objId, positions) {
    var material = Cesium.Color.fromCssColorString("#ff0").withAlpha(0.5);
    var outlineMaterial = new Cesium.PolylineDashMaterialProperty({
      dashLength: 16,
      color: Cesium.Color.fromCssColorString("#f00").withAlpha(0.7),
    });
    var outlinePositions = [].concat(positions);
    outlinePositions.push(positions[0]);
    var bData = {
      layerId: ENV.DRAW_LAYER_ID,
      objId: objId,
      shapeType: "StraightArrow",
      polyline: {
        positions: outlinePositions,
        clampToGround: true,
        width: 2,
        material: outlineMaterial,
      },
      polygon: new Cesium.PolygonGraphics({
        hierarchy: positions,
        asynchronous: false,
        material: material,
      }),
    };
    var entity = this.viewer.entities.add(bData);
  }

  showAttackArrow(objId, positions) {
    var material = Cesium.Color.fromCssColorString("#ff0").withAlpha(0.5);
    var outlineMaterial = new Cesium.PolylineDashMaterialProperty({
      dashLength: 16,
      color: Cesium.Color.fromCssColorString("#f00").withAlpha(0.7),
    });
    var outlinePositions = [].concat(positions);
    outlinePositions.push(positions[0]);
    var bData = {
      layerId: ENV.DRAW_LAYER_ID,
      objId: objId,
      shapeType: "AttackArrow",
      polyline: {
        positions: outlinePositions,
        clampToGround: true,
        width: 2,
        material: outlineMaterial,
      },
      polygon: new Cesium.PolygonGraphics({
        hierarchy: positions,
        asynchronous: false,
        material: material,
      }),
    };
    var entity = this.viewer.entities.add(bData);
  }

  showPincerArrow(objId, positions) {
    var material = Cesium.Color.fromCssColorString("#ff0").withAlpha(0.5);
    var outlineMaterial = new Cesium.PolylineDashMaterialProperty({
      dashLength: 16,
      color: Cesium.Color.fromCssColorString("#f00").withAlpha(0.7),
    });
    var outlinePositions = [].concat(positions);
    outlinePositions.push(positions[0]);
    var bData = {
      layerId: ENV.DRAW_LAYER_ID,
      objId: objId,
      shapeType: "PincerArrow",
      polyline: {
        positions: outlinePositions,
        clampToGround: true,
        width: 2,
        material: outlineMaterial,
      },
      polygon: new Cesium.PolygonGraphics({
        hierarchy: positions,
        asynchronous: false,
        material: material,
      }),
    };
    var entity = this.viewer.entities.add(bData);
  }

  editPolygon(objId, callback) {
    var oldPositions =
      app.shapeDic[objId] != undefined
        ? app.shapeDic[objId]
        : this.viewer.entities.getById(objId);
    // CustomArea
    if (oldPositions == undefined && app.shapeDic[objId] == undefined) {
      this.editCustomArea(objId, true);
      return;
    }

    //Retirer d'abord l'entité.
    this.clearEntityById(objId);
    //Aller à Modifier
    app.drawTracker.polygonDrawer.showModifyPolygon(
      oldPositions,
      (positions) => {
        app.shapeDic[objId] = positions;
        this.showPolygon(objId, positions);
      },
      () => {
        this.showPolygon(objId, oldPositions);
      }
    );
  }

  editCustomArea(objId, fromPolygon) {
    if (fromPolygon !== undefined) {
      var oldPositions = OLDPOSITION;
    } else {
      var oldPositions =
        app.shapeDic[objId] != undefined
          ? app.shapeDic[objId]
          : viewer.entities.getById(objId);

      OLDPOSITION = oldPositions;
    }
    //Retirer d'abord l'entité.
    this.clearEntityById(objId);
    //Aller à Modifier
    app.drawTracker.fh_customarea.showModifyPolygon(
      oldPositions,
      objId,
      (positions) => {
        app.shapeDic[objId] = positions;
        this.showCustomArea(objId, positions);
        app.map_draw["CustomArea--update"](objId);
      },
      () => {
        this.showCustomArea(objId, oldPositions);
        app.map_draw["CustomArea--cancel"](objId);
      }
    );
  }

  editPolyline(objId) {
    var oldPositions = app.shapeDic[objId];

    //Retirer d'abord l'entité.
    this.clearEntityById(objId);

    //Aller à Modifier
    app.drawTracker.polylineDrawer.showModifyPolyline(
      oldPositions,
      (positions) => {
        app.shapeDic[objId] = positions;
        this.showPolyline(objId, positions);
      },
      () => {
        this.showPolyline(objId, oldPositions);
      }
    );
  }

  editRectangle(objId) {
    var oldPositions = app.shapeDic[objId];

    //Retirer d'abord l'entité.
    this.clearEntityById(objId);
    //Aller à Modifier
    app.drawTracker.rectDrawer.showModifyRectangle(
      oldPositions,
      (positions) => {
        app.shapeDic[objId] = positions;
        this.showRectangle(objId, positions);
      },
      () => {
        this.showRectangle(objId, oldPositions);
      }
    );
  }

  editCircle(objId) {
    var oldPositions = app.shapeDic[objId];

    //Retirer d'abord l'entité.
    this.clearEntityById(objId);

    //Aller à Modifier
    app.drawTracker.circleDrawer.showModifyCircle(
      oldPositions,
      (positions) => {
        app.shapeDic[objId] = positions;
        this.showCircle(objId, positions);
      },
      () => {
        this.showCircle(objId, oldPositions);
      }
    );
  }

  editPoint(objId, callback) {
    var oldPosition = app.shapeDic[objId];

    if (oldPosition == undefined) {
      oldPosition = viewer.entities.getById(objId).position._value;
    }
    //Retirer d'abord l'entité.
    this.clearEntityById(objId);

    //Aller à Modifier
    app.drawTracker.pointDrawer.showModifyPoint(
      oldPosition,
      (position) => {
        app.shapeDic[objId] = position;
        this.showPoint(objId, position);
      },
      () => {
        this.showPoint(objId, oldPosition);
      }
    );
  }

  editBufferLine(objId) {
    var old = app.shapeDic[objId];

    //Retirer d'abord l'entité.
    this.clearEntityById(objId);

    //Aller à Modifier
    app.drawTracker.bufferLineDrawer.showModifyBufferLine(
      old.positions,
      old.radius,
      (positions, radius) => {
        app.shapeDic[objId] = {
          positions: positions,
          radius: radius,
        };
        this.showBufferLine(objId, positions, radius);
      },
      () => {
        this.showBufferLine(old.positions, old.radius, oldPositions);
      }
    );
  }

  editStraightArrow(objId) {
    var oldPositions = app.shapeDic[objId];

    //Retirer d'abord l'entité.
    this.clearEntityById(objId);

    //Aller à Modifier
    app.drawTracker.straightArrowDrawer.showModifyStraightArrow(
      oldPositions,
      (positions) => {
        app.shapeDic[objId] = positions;
        this.showStraightArrow(objId, positions);
      },
      () => {
        this.showStraightArrow(objId, oldPositions);
      }
    );
  }

  editAttackArrow(objId) {
    var old = app.shapeDic[objId];

    //Retirer d'abord l'entité.
    this.clearEntityById(objId);

    app.drawTracker.attackArrowDrawer.showModifyAttackArrow(
      old.custom,
      (positions, custom) => {
        //Sauvegarder les résultats de l'édition
        app.shapeDic[objId] = {
          custom: custom,
          positions: positions,
        };
        this.showAttackArrow(objId, positions);
      },
      () => {
        this.showAttackArrow(objId, old.positions);
      }
    );
  }

  editPincerArrow(objId) {
    var old = app.shapeDic[objId];

    //Retirer d'abord l'entité.
    this.clearEntityById(objId);

    app.drawTracker.pincerArrowDrawer.showModifyPincerArrow(
      old.custom,
      (positions, custom) => {
        //Sauvegarder les résultats de l'édition
        app.shapeDic[objId] = {
          custom: custom,
          positions: positions,
        };
        this.showPincerArrow(objId, positions);
      },
      () => {
        this.showPincerArrow(objId, old.positions);
      }
    );
  }

  clearEntityById(objId) {
    var entityList = this.viewer.entities.values;
    if (entityList == null || entityList.length < 1) {
      return;
    }
    for (var i = 0; i < entityList.length; i++) {
      var entity = entityList[i];
      if (entity.layerId == ENV.DRAW_LAYER_ID && entity.objId == objId) {
        this.viewer.entities.remove(entity);
        delete app.shapeDic[objId];
        i--;
      }
    }
  }

  deleteEntityById(objId) {
    this.viewer.entities.removeById(objId);
  }

  /** --- */
  /** --- */
  /** --- */
  /** --- */
  /** --- */
  /** --- */

  bindTrackerEvent() {
    this.viewer.camera.moveEnd.addEventListener((event) => {
      let canvas = this.viewer.scene.canvas;
      let ellipsoid = this.viewer.scene.globe.ellipsoid;

      let p1 = new Cesium.Cartesian2(0, 0);
      let p2 = new Cesium.Cartesian2(canvas.clientWidth, canvas.clientHeight);

      p1 = this.viewer.camera.pickEllipsoid(p1, ellipsoid);
      p2 = this.viewer.camera.pickEllipsoid(p2, ellipsoid);

      if (p1 == undefined || p2 == undefined) {
        return;
      }

      let Xmin = Cesium.Math.toDegrees(
        Cesium.Cartographic.fromCartesian(p1).longitude
      );
      let Xmax = Cesium.Math.toDegrees(
        Cesium.Cartographic.fromCartesian(p2).longitude
      );
      let Ymin = Cesium.Math.toDegrees(
        Cesium.Cartographic.fromCartesian(p2).latitude
      );
      let Ymax = Cesium.Math.toDegrees(
        Cesium.Cartographic.fromCartesian(p1).latitude
      );

      if (
        Xmin == undefined ||
        Xmax == undefined ||
        Ymin == undefined ||
        Ymax == undefined
      ) {
        return;
      }

      app.updateTracker(
        {
          Xmin: Xmin,
          Xmax: Xmax,
          Ymin: Ymin,
          Ymax: Ymax,
        },
        "move"
      );
    });
  }

  force2d() {
    if (this.autoPitch.active == true) {
      this.autoPitch.sens = !this.autoPitch.sens;
    } else {
      let canvas = this.viewer.scene.canvas;
      let position = new Cesium.Cartesian2(
        canvas.clientWidth / 2,
        canvas.clientHeight / 2
      );
      let cartesian = this.viewer.scene.pickPosition(position);
      if (!Cesium.defined(cartesian)) {
        // console.log("pickTerrain");
        cartesian = this.pickTerrain(position);
      }
      if (Cesium.defined(cartesian)) {
        const range = Cesium.Cartesian3.distance(
          cartesian,
          this.viewer.scene.camera.position
        );
        const transform = Cesium.Transforms.eastNorthUpToFixedFrame(cartesian);
        const heading = this.viewer.scene.camera.heading;

        this.autoPitch.active = true;
        this.autoPitch.range = range;
        this.autoPitch.heading = heading;
        this.autoPitch.pitch = this.viewer.scene.camera.pitch;
        this.autoPitch.transform = transform;
        this.autoPitch.sens = !this.autoPitch.sens;
      } else {
        this.autoPitch.sens = false;
        this.viewer.camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
      }
    }

    if (this.autoPitch.sens == false) {
      this.viewer.scene.screenSpaceCameraController.zoomEventTypes = [1, 3, 4];
      //this.viewer.scene.screenSpaceCameraController.tiltEventTypes = [Cesium.CameraEventType.MIDDLE_DRAG, Cesium.CameraEventType.PINCH, { eventType : Cesium.CameraEventType.LEFT_DRAG, modifier : Cesium.KeyboardEventModifier.CTRL }, { eventType : Cesium.CameraEventType.RIGHT_DRAG, modifier : Cesium.KeyboardEventModifier.CTRL }];
      //this.viewer.scene.screenSpaceCameraController.enableTilt = true;
    } else {
      this.viewer.scene.screenSpaceCameraController.zoomEventTypes = [3];
      //this.viewer.scene.screenSpaceCameraController.tiltEventTypes = [];
      //this.viewer.scene.screenSpaceCameraController.enableTilt = false;
    }
  }

  setFog() {
    this.viewer.scene.fog.enabled = $root.user.getSettingsFog();

    //this.viewer.terrainShadows = active ? Cesium.ShadowMode.ENABLED : Cesium.ShadowMode.DISABLED;
  }

  flyToBbox(bbox) {
    const rectangle = Cesium.Rectangle.fromDegrees(
      bbox.xmin,
      bbox.ymin,
      bbox.xmax,
      bbox.ymax
    );
    this.viewer.camera.flyTo({ destination: rectangle });
  }

  flyToRectangle(rectangle) {
    if (Cesium.defined(rectangle)) {
      this.viewer.camera.flyTo({
        destination: rectangle,
        orientation: {
          heading: Cesium.Math.toRadians(0.0),
          pitch: Cesium.Math.toRadians(-55.0),
          roll: 0.0
        },
      });
    }
  }

  getCenterRectangle(bbox) {
    const rectangle = Cesium.Rectangle.fromDegrees(
      bbox.xmin,
      bbox.ymin,
      bbox.xmax,
      bbox.ymax
    );
    const center = Cesium.Rectangle.center(rectangle);
    const pos = [
      (center.longitude / Math.PI) * 180,
      (center.latitude / Math.PI) * 180,
    ];

    return pos;
  }

  isCustomElementOpen(mapElement) {
    if (app.popupMapElements && this.getCustomMapElement()) {
      const id = this.getCustomMapElement().getId();
      if (id === mapElement.getId()) {
        return true;
      }
    }
    return false;
  }

  toggle_popup_mapelement(active) {
    app.popupMapElements = active;
  }

  setCustomMapElement(mapElement) {
    app.customMapElement = mapElement;
    if (app.Map_MapElementsRef) {
      app.Map_MapElementsRef.refresh();
    }
  }

  saveCustomMapElement() {
    if (app.Map_MapElementsRef) {
      app.Map_MapElementsRef.saveGeom();
    }
  }

  getCustomMapElement() {
    return app.customMapElement;
  }

  updateCustomMapElement(mapElement) {
    if (this.isCustomElementOpen(mapElement)) {
      //// console.log("ok",  mapElement,  app.customMapElement);
      this.setCustomMapElement(mapElement);
    }
  }

  flyToEntity(entity) {
    if (entity.polygon) {
      const sphere = Cesium.BoundingSphere.fromPoints(
        entity.polygon.hierarchy.getValue().positions
      );
      sphere.radius *= 1.5;
      this.viewer.camera.flyToBoundingSphere(sphere);
    } else if (entity.polyline) {
      const sphere = Cesium.BoundingSphere.fromPoints(
        entity.polyline.positions.getValue()
      );
      sphere.radius *= 1.5;
      this.viewer.camera.flyToBoundingSphere(sphere);
    } else {
      this.viewer.flyTo(entity, {
        duration: 2.0,
        offset: new Cesium.HeadingPitchRange(
          Cesium.Math.toRadians(0),
          Cesium.Math.toRadians(-40),
          500
        ),
      });
    }
  }

  setInfosCameraPos(infosCamera) {
    app.infosCamera = infosCamera;
  }

  toggle_popup_contextmenu(active) {
    app.popupContextMenu = active;
  }
  setInfosContextMenu(infos) {
    if (infos != undefined) {
      //masquer ajouter waypoint.
      app.popupContextMenuWaypoint = false;

      app.infosContextMenu = infos;
      this.toggle_popup_contextmenu(true);
    }
    else {
      this.toggle_popup_contextmenu(false);
    }
  }

  toggle_popup_drawhelp(active) {
    app.popupDrawHelp = active;
  }

  setInfosDrawHelp(infos) {
    if (infos != null && infos != "") {
      const showHelp = $root.user.getSettingsHelpDraw();
      if (showHelp) {
        app.infosDrawHelp = infos;
        this.toggle_popup_drawhelp(true);

        if (this.timerDrawHelp != undefined) {
          clearTimeout(this.timerDrawHelp);
        }
        this.timerDrawHelp = setTimeout(() => {
          this.toggle_popup_drawhelp(false);
        }, 5000);
      }
    }
    else {
      this.toggle_popup_drawhelp(false);
    }
  }



  getKeyPressed() {
    const keyboard = app.getFlightsKeyboardRef();
    if (keyboard) {
      return app.getFlightsKeyboardRef().pressedKey;
    }
    return [];
  }

  setKeyInfos(Longitude, latitude, altitude, heading, speed, follow) {
    const keyboard = app.getFlightsKeyboardRef();
    if (keyboard) {
      app.getFlightsKeyboardRef().longitude = Longitude.toFixed(9);
      app.getFlightsKeyboardRef().latitude = latitude.toFixed(9);
      app.getFlightsKeyboardRef().alt = altitude.toFixed(1);
      app.getFlightsKeyboardRef().yaw = heading.toFixed(1);
      app.getFlightsKeyboardRef().speed = speed.toFixed(1);
      app.getFlightsKeyboardRef().followType = follow === true ? 0 : 1;
      app.getFlightsKeyboardRef().forceRerenderKeyBoard();
    }
  }

  toggle_popup_contextmenuwaypoint(active) {
    this.enableMouseZoom(!active);
    app.popupContextMenuWaypoint = active;
  }

  setInfosContextMenuWaypt(infos) {

    //la fenetre supprimer point doit etre refermee
    if (infos != undefined && app.popupContextMenu === false) {
      app.infosContextMenuWaypoint = infos;
      this.toggle_popup_contextmenuwaypoint(true);
    }
    else {
      this.toggle_popup_contextmenuwaypoint(false);
    }
  }

  toggle_popup_contextmenuwaypointDelete(active) {
    this.enableMouseZoom(!active);
    app.popupContextMenuWaypointDelete = active;
  }

  setInfosContextMenuWayptDelete(infos) {
    if (infos != undefined) {
      app.infosContextMenuWaypoint = infos;
      this.toggle_popup_contextmenuwaypointDelete(true);
    }
    else {
      this.toggle_popup_contextmenuwaypointDelete(false);
    }
  }



  setMapAction(infos) {
    $root.global.flightedit.mapAction = infos;
  }

  setWptCoords(step, coords) {

  }

  enableMouseZoom(isEnable) {
    if (this.viewer != undefined) {
      this.viewer.scene.screenSpaceCameraController.enableZoom = isEnable;
    }

  }


  setFlightHistoryDroneTrace(datas) {
    let flightHistory = [];

    datas.forEach((data) => {
      if (data?.val?.dronepos) {
        let dronepos = data.val.dronepos;

        flightHistory.push(dronepos.longitude);
        flightHistory.push(dronepos.latitude);
        flightHistory.push(dronepos.height);
      }
    });

    let entity = this.viewer.entities.add({
      polyline: {
        positions: Cesium.Cartesian3.fromDegreesArrayHeights(flightHistory),
        width: 5,
        material: new Cesium.PolylineOutlineMaterialProperty({
          color: Cesium.Color.ORANGE,
          outlineWidth: 2,
          outlineColor: Cesium.Color.BLACK,
        }),
      }
    })

    return entity;
  }

  setFlightHistoryDock(datas) {
    let colection = []

    datas.forEach((data) => {
      if (data?.val?.dockpos) {
        let dockpos = data.val.dockpos;

        let entity = this.viewer.entities.add({
          position: Cesium.Cartesian3.fromDegrees(
            dockpos.longitude,
            dockpos.latitude,
            dockpos.height
          ),
          ellipse: {
            semiMinorAxis: 1,
            semiMajorAxis: 1,
            height: dockpos.height,
            extrudedHeight: dockpos.height - 0.5,
            material: Cesium.Color.ORANGE,
            outline: true, // height must be set for outline to display
          },
        })

        colection.push(entity);
      }
    })

    return colection;
  }

  setFlightHistoryDrone(drone) {
    let url = window.location.origin + "/assets/3dModel/FlecheFlyinEye.glb";
    // console.log(drone);
    let position = drone != undefined
      ? Cesium.Cartesian3.fromDegrees(
        drone.longitude,
        drone.latitude,
        drone.height
      )
      : new Cesium.Cartesian3(0, 0, 0);

    let drone_orientation = drone?.attitude_head && drone?.attitude_pitch && drone?.attitude_roll
      ? new Cesium.HeadingPitchRoll(
        Cesium.Math.toRadians(drone.attitude_head),
        Cesium.Math.toRadians(drone.attitude_pitch),
        Cesium.Math.toRadians(drone.attitude_roll)
      )
      : new Cesium.HeadingPitchRoll(0, 0, 0)

    let orientation = Cesium.Transforms.headingPitchRollQuaternion(
      position,
      drone_orientation
    );

    let entity = this.viewer.entities.add({
      position: position,
      orientation: orientation,
      model: {
        uri: url,
        scale: 10,//0.003,
        distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, this.get_max_distance_show()),
        zIndex: 999,
        colorBlendMode: Cesium.ColorBlendMode.REPLACE,
        colorBlendAmount: 1,
        color: Cesium.Color.fromCssColorString("#ffff00"),
        shadows: Cesium.ShadowMode.DISABLED,
      },
    });

    return entity;
  }
}

export default new Map();
